import type { CompoundMarketTemplateProps, MarketTemplateProps } from '@swf/sports/types/templates';

export const isCompoundMarketTemplateProps = (
  props: MarketTemplateProps
): props is CompoundMarketTemplateProps => 'marketIds' in props && 'config' in props;
